import { ThemeProvider } from "styled-components";
import { useState, useEffect } from "react";
import { darkTheme, lightTheme } from "./utils/Themes.js";
import Navbar from "./components/Navbar";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import ProjectDetails from "./components/ProjectDetails";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";
import styled from "styled-components";

const Body = styled.div`
  background:
    radial-gradient(900px 420px at 100% -8%, rgba(109, 40, 217, 0.1), transparent 60%),
    radial-gradient(720px 380px at -8% 12%, rgba(219, 39, 119, 0.07), transparent 55%),
    ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  padding-top: 80px;
`;

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  const [darkMode] = useState(false);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <ScrollToTop />
        <Navbar />
        <Body>
          <Routes>
            <Route
              path="/"
              element={<Home openModal={openModal} setOpenModal={setOpenModal} />}
            />
            <Route path="/about" element={<AboutPage />} />
            <Route
              path="/projects"
              element={<ProjectsPage openModal={openModal} setOpenModal={setOpenModal} />}
            />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          {openModal.state && (
            <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
          )}
        </Body>
      </Router>
    </ThemeProvider>
  );
}

export default App;
